import classes from "../styles/App.module.scss";
import { FC } from "react";

type Props = {
    inputElement: React.RefObject<HTMLInputElement>;
    onClickAddButton: () => void;
    handleKeyDown: (event: React.KeyboardEvent) => void;
    handleComposition:(event: React.CompositionEventHandler<HTMLInputElement> | any) => void;
}

export const InputArea: FC<Props> = props => {
    const { inputElement, handleKeyDown, handleComposition, onClickAddButton } = props;

    return (
        <div className={classes.inputArea}>
        <input ref={inputElement} onKeyDown={handleKeyDown} onCompositionStart={handleComposition} onCompositionEnd={handleComposition} className={classes.inputAreaTextArea} type="text" placeholder="メモを入力" />
        <button onClick={onClickAddButton} className={classes.inputAreaButton}>追加</button>
      </div>
    )
}